import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchEnabledShippingTypes } from 'api/fetchers/get-enabled-shipping-types';
import { EnabledShippingTypesResponse_Data } from '../../../../pb/responses/v1/enabled_shipping_types_response_pb';

export const getEnabledShippingTypes = createAsyncThunk<
    EnabledShippingTypesResponse_Data[],
    void,
    { rejectValue: string }
>('[enabledShippingTypes] getEnabledShippingTypes', async (_, { rejectWithValue }) => {
    return await fetchEnabledShippingTypes()
        .then((response) => {
            return response?.data;
        })
        .catch((error) => {
            return rejectWithValue(error as string);
        });
});
